import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

import ipetImg from '../assets/yonetim/ipetmutlu.png';
import ersinImg from '../assets/yonetim/ersinozkan.png';
import muzafferImg from '../assets/yonetim/muzafferadak.png';
import aysunImg from '../assets/yonetim/aysundarici.png';
import muratImg from '../assets/yonetim/muratfidan.png';
import burcuImg from '../assets/yonetim/burcuyildirim.png';

const members = [
  {
    img: ipetImg,
    name: "— H. İPET MUTLU",
    role: "YÖNETİM KURULU BAŞKANI",
    isChairman: true
  },
  {
    img: ersinImg,
    name: "— H. ERSİN ÖZKAN",
    role: "YÖNETİM KURULU ÜYESİ",
  },
  {
    img: muzafferImg,
    name: "— MUZAFFER ADAK",
    role: "YÖNETİM KURULU ÜYESİ",
  },
  {
    img: aysunImg,
    name: "— N. AYSUN DARICI",
    role: "YÖNETİM KURULU ÜYESİ",
  },
  {
    img: muratImg,
    name: "— MURAT FİDAN",
    role: "YÖNETİM KURULU ÜYESİ",
  },
  {
    img: burcuImg,
    name: "— BURCU YILDIRIM",
    role: "YÖNETİM KURULU ÜYESİ",
  },
];

const MemberCard: React.FC<{ m: any, isMobile: boolean, isChairman?: boolean }> = ({ m, isMobile, isChairman }) => (
  <motion.div
    initial={{ opacity: 0, scale: 0.9 }}
    whileInView={{ opacity: 1, scale: 1 }}
    viewport={{ once: true }}
    style={{
      minWidth: isMobile ? (isChairman ? 200 : 160) : 260,
      maxWidth: isMobile ? (isChairman ? 200 : 160) : 260,
      background: '#fff',
      color: '#333',
      borderRadius: isMobile ? 20 : 28,
      border: '1px solid rgba(15, 45, 94, 0.08)',
      overflow: 'hidden',
      fontFamily: "'Inter', sans-serif",
      boxShadow: '0 10px 30px rgba(15, 45, 94, 0.05)',
      flexShrink: 0,
      position: 'relative',
      zIndex: 2
    }}
  >
    <div style={{
      position: 'relative',
      padding: isMobile ? '12px 12px 0 12px' : '0',
      display: 'flex',
      justifyContent: 'center'
    }}>
      <img
        src={m.img}
        alt={m.name}
        loading="lazy"
        style={{
          width: '100%',
          height: isMobile ? (isChairman ? 180 : 150) : 280,
          aspectRatio: isMobile ? '1 / 1' : 'unset',
          objectFit: 'cover',
          objectPosition: 'top',
          display: 'block',
          borderRadius: isMobile ? '14px' : '0'
        }}
      />
    </div>
    <div style={{ padding: isMobile ? '12px' : '20px', borderTop: '1px solid rgba(15, 45, 94, 0.08)' }}>
      <p style={{ fontSize: isMobile ? 12 : 15, fontWeight: 700, color: '#0f2d5e', margin: '0 0 4px 0', lineHeight: 1.2 }}>{m.name}</p>
      <p style={{
        fontSize: isMobile ? 9 : 10,
        fontWeight: 800,
        letterSpacing: '0.05em',
        margin: 0,
        display: 'inline-block',
        background: 'linear-gradient(to right, #0f2d5e, #e65100)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
      }}>{m.role}</p>
    </div>
  </motion.div>
);

const YonetimKurulu: React.FC = () => {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);

  useEffect(() => {
    document.title = "Flying Slap - Yönetim Kurulumuz";
    window.scrollTo(0, 0);

    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="relative text-gray-900 overflow-hidden font-body min-h-screen bg-white" style={{ paddingTop: '140px' }}>
      <div className="max-w-7xl mx-auto px-6" style={{ paddingBottom: '60px' }}>
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          {/* Header Section */}
          <div style={{
            minHeight: isMobile ? '100vh' : 'auto',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: isMobile ? 'center' : 'flex-start',
            marginTop: isMobile ? '-140px' : '0', // Offset the paddingTop of parent to truly center in viewport
            paddingTop: isMobile ? '140px' : '0',
            paddingBottom: isMobile ? '100px' : '0', // Shift up on mobile
            position: 'relative' // Added for absolute positioning of line
          }}>
            <h1 className="font-headline font-black uppercase tracking-tighter text-center" style={{
              color: '#0f2d5e',
              fontSize: isMobile ? '4.2rem' : 'clamp(2.2rem, 7vw, 3.8rem)',
              lineHeight: isMobile ? 0.85 : 1.1,
              marginBottom: '30px'
            }}>
              YÖNETİM{isMobile ? <br /> : ' '}
              <span style={{ color: '#e65100' }}>KURULUMUZ</span>
            </h1>
            <div className="mx-auto" style={{
              maxWidth: '850px',
              background: 'rgba(15, 45, 94, 0.03)',
              padding: '32px 40px',
              borderRadius: '24px',
              border: '1px solid rgba(15, 45, 94, 0.08)',
              marginBottom: isMobile ? '0' : '80px'
            }}>
              <p className="text-center" style={{
                fontSize: isMobile ? '1.1rem' : '1rem',
                color: '#4b5563',
                lineHeight: 1.7,
                margin: 0,
                fontWeight: 400
              }}>
                Havacılık tutkumuzu vizyoner kararlar ve yenilikçi stratejilerle geleceğe taşıyan <strong style={{ color: '#e65100' }}>yönetim kurulumuzla</strong> tanışın.
              </p>
            </div>

            {/* Mobile indicator line */}
            {isMobile && (
              <motion.div
                animate={{ y: [0, 10, 0] }}
                transition={{ repeat: Infinity, duration: 2, ease: 'easeInOut' }}
                style={{
                  position: 'absolute',
                  bottom: 32,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: 1,
                  height: 56,
                  background: 'linear-gradient(to bottom, #e65100, transparent)'
                }}
              />
            )}
          </div>

          {/* Organization Chart Layout */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '40px',
            position: 'relative'
          }}>
            {/* Level 1: Chairman */}
            <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <MemberCard m={members[0]} isMobile={isMobile} isChairman={true} />
            </div>

            {/* Level 2: Board Members */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)',
              gap: isMobile ? '16px' : '40px',
              marginTop: isMobile ? '0' : '40px',
              width: '100%',
              justifyItems: 'center',
              position: 'relative',
              padding: isMobile ? '0 10px' : '0'
            }}>

              {members.slice(1).map((m, idx) => (
                <MemberCard key={idx} m={m} isMobile={isMobile} />
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default YonetimKurulu;
